import { render, staticRenderFns } from "./IntegratedMarketingList.vue?vue&type=template&id=8e708c72"
import script from "./IntegratedMarketingList.vue?vue&type=script&lang=js"
export * from "./IntegratedMarketingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports